const barcode = require('./barcode');
var contract_page = {
    init: function () {
        var $this = this;

        var contractCodeSet = typeof contractCode != "undefined";
        var subcontractCodeSet = typeof subcontractCode != "undefined";

        if (contractCodeSet == false || subcontractCodeSet == false) {

            var onSubmit = function (value) {
                $("input[type='hidden'][name='barcode']").val(value);
                $("input[type='submit']").click();
            }

            if (contractCodeSet == false) {
                barcode.init($("#contract_code"), onSubmit);
            } else {
                barcode.init($("#subcontract_code"), onSubmit);
            }
        } else if (contractCodeSet === true && subcontractCodeSet === true) {
            var $inputElement = $("input[name='units']");
            $inputElement.cursorFocus();

            const selectId = '#charge_select';
            var $selectElement = $(selectId);


            /* keep focus on time set, but enable select */
            $(document).on('pointerdown', selectId, function () {
                $(this).addClass('is-open');
            });

            // zavření po výběru nebo ztrátě focusu
            $(document).on('change blur', selectId, function () {
                $(this).removeClass('is-open');
            });

            // zavření přes klávesu ESC
            $(document).on('keydown', selectId, function (e) {
                if (e.key === 'Escape' || e.key === 'Esc') {
                    $(this).removeClass('is-open');
                }
            });

            $selectElement.on('change', function () {
                setTimeout(function () {
                    $inputElement.cursorFocus();
                }, 50);
            })

            // kontroluje focus inputu pro scanovani
            // jen pokud neni otevreno okno iziToast
            $inputElement.on('blur', function () {
                var blurEl = $(this);
                if (!$selectElement.hasClass("is-open")) {
                    setTimeout(function () {
                        blurEl.cursorFocus();
                    }, 500);
                }
            });
        }

        if ($("#contract_code").length && !contractCodeSet && (typeof contractSuggest !== 'undefined') && contractSuggest.length) {
            $("#contract_code").autocomplete({
                minLength: 2,
                source: function (request, response) {
                    /* Remove the spaces from the search term: */
                    var term = request.term.replace(/\s/g, '');
                    var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");

                    response($.map(contractSuggest, function (el) {
                        /* Remove dashes from the source and compare with the term: */
                        if (matcher.test(el['value'].replace(/\s/g, ''))) {
                            return el;
                        }
                    }));
                },
                focus: function (event, ui) {
                    $("#contract_code").val(ui.item.text);
                    return false;
                },
                select: function (event, ui) {
                    $("#contract_code").val(ui.item.text);
                    if (!$(event.originalEvent.originalEvent.originalEvent.srcElement).hasClass('ui-menu-item-fill')) {
                        $("#search__form .submit").click();
                    }
                    return false;
                }
            }).autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append("<div><span>" + item.text + "</span><div class='ui-menu-item-fill'></div></div>")
                    .appendTo(ul);
            };
        }

        if ($("#subcontract_code").length && !subcontractCodeSet && (typeof subcontractSuggest !== 'undefined') && subcontractSuggest.length) {
            $("#subcontract_code").autocomplete({
                minLength: 0,
                source: function (request, response) {
                    /* Remove the spaces from the search term: */
                    var term = request.term.replace(/\s/g, '');
                    var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");

                    response($.map(subcontractSuggest, function (el) {
                        /* Remove dashes from the source and compare with the term: */
                        if (matcher.test(el['value'].replace(/\s/g, ''))) {
                            return el;
                        }
                    }));
                },
                focus: function (event, ui) {
                    $("#subcontract_code").val(ui.item.text);
                    return false;
                },
                select: function (event, ui) {
                    $("#subcontract_code").val(ui.item.text);
                    if (!$(event.originalEvent.originalEvent.originalEvent.srcElement).hasClass('ui-menu-item-fill')) {
                        $("#search__form .submit").click();
                    }
                    return false;
                }
            });
            $("#subcontract_code").autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append("<div><span>" + item.text + "</span><div class='ui-menu-item-fill'></div></div>")
                    .appendTo(ul);
            };
            $("#subcontract_code").autocomplete("instance")._resizeMenu = function (ul, item) {
                let menu = $(this.menu.element);
                menu.css('height', 'auto');
                let inputTop = menu.offset().top;
                let inputHeight = $("#subcontract_code").height();
                let autocompleteHeight = $("#subcontract_code").autocomplete("widget").height(); // changed
                let windowHeight = $(window).height();
                let windowTop = $(window).scrollTop();

                if ((inputHeight + autocompleteHeight) > (windowHeight - inputTop - inputHeight)) {
                    menu.css('height', (windowHeight - inputTop + windowTop - 20) + 'px');
                    menu.css('overflow-y', 'auto');
                    menu.css('overflow-x', 'hidden');
                    menu.css('min-height', '50px');
                }
            };

            $("#subcontract_code").focus(function () {
                // tady je to 2x, protoze podruhe uz mam ve fci _resizeMenu spravne umisteni....
                $(this).data("uiAutocomplete").search($(this).val());
                $(this).data("uiAutocomplete").search($(this).val());
            });

            if (subcontractSuggest.length < 15) {
                $("#subcontract_code").autocomplete("search", "");
            }
        }


    }
}

module.exports = contract_page;